import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

// ENS MEDIO+ CAT Catalog - Spanish National Security Framework
// 69 controls organized into 3 main domains: MO (Marco Organizativo), MP (Marco de Protección), MO (Marco Operacional)
// Total: ~120 assessment points with proper codes, weights, and EN/ES/RU localization

export const ENS_MEDIO_MO_ORGANIZATIVO_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-mo-01-politica-seguridad',
    name_en: 'ENS-MO-01 — Security Policy',
    name_es: 'ENS-MO-01 — Política de Seguridad',
    name_ru: 'ENS-MO-01 — Политика безопасности',
    questions: [
      {
        id: 'ENS-MO-01',
        blockId: 'ens-mo-01-politica-seguridad',
        text_en: 'Security Policy - Is there a documented and approved information security policy?',
        text_es: 'Política de Seguridad - ¿Existe una política de seguridad de la información documentada y aprobada?',
        text_ru: 'Политика безопасности - Существует ли документированная и утвержденная политика информационной безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-03-responsabilidades-cis',
    name_en: 'ENS-MO-03 — CIS Responsibilities',
    name_es: 'ENS-MO-03 — Responsabilidades CIS',
    name_ru: 'ENS-MO-03 — Ответственность CIS',
    questions: [
      {
        id: 'ENS-MO-03',
        blockId: 'ens-mo-03-responsabilidades-cis',
        text_en: 'CIS Responsibilities - Are cybersecurity responsibilities clearly defined and assigned?',
        text_es: 'Responsabilidades CIS - ¿Las responsabilidades de ciberseguridad están claramente definidas y asignadas?',
        text_ru: 'Ответственность CIS - Четко ли определены и назначены обязанности по кибербезопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-04-organizacion-seguridad',
    name_en: 'ENS-MO-04 — Security Organization',
    name_es: 'ENS-MO-04 — Organización de Seguridad',
    name_ru: 'ENS-MO-04 — Организация безопасности',
    questions: [
      {
        id: 'ENS-MO-04',
        blockId: 'ens-mo-04-organizacion-seguridad',
        text_en: 'Security Organization - Is the security organizational structure defined?',
        text_es: 'Organización de Seguridad - ¿La estructura organizativa de seguridad está definida?',
        text_ru: 'Организация безопасности - Определена ли организационная структура безопасности?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-05-gestion-activos',
    name_en: 'ENS-MO-05 — Asset Management',
    name_es: 'ENS-MO-05 — Gestión de Activos',
    name_ru: 'ENS-MO-05 — Управление активами',
    questions: [
      {
        id: 'ENS-MO-05',
        blockId: 'ens-mo-05-gestion-activos',
        text_en: 'Asset Management - Is an asset inventory maintained and classified?',
        text_es: 'Gestión de Activos - ¿Se mantiene y clasifica un inventario de activos?',
        text_ru: 'Управление активами - Ведется ли и классифицируется ли реестр активов?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-06-gestion-riesgos',
    name_en: 'ENS-MO-06 — Risk Management',
    name_es: 'ENS-MO-06 — Gestión de Riesgos',
    name_ru: 'ENS-MO-06 — Управление рисками',
    questions: [
      {
        id: 'ENS-MO-06',
        blockId: 'ens-mo-06-gestion-riesgos',
        text_en: 'Risk Management - Is a risk management process implemented?',
        text_es: 'Gestión de Riesgos - ¿Se implementa un proceso de gestión de riesgos?',
        text_ru: 'Управление рисками - Реализован ли процесс управления рисками?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-07-gestion-personal',
    name_en: 'ENS-MO-07 — Personnel Management',
    name_es: 'ENS-MO-07 — Gestión del Personal',
    name_ru: 'ENS-MO-07 — Управление персоналом',
    questions: [
      {
        id: 'ENS-MO-07',
        blockId: 'ens-mo-07-gestion-personal',
        text_en: 'Personnel Management - Are personnel security procedures implemented?',
        text_es: 'Gestión del Personal - ¿Se implementan procedimientos de seguridad del personal?',
        text_ru: 'Управление персоналом - Реализованы ли процедуры безопасности персонала?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-08-gestion-proveedores',
    name_en: 'ENS-MO-08 — Supplier Management',
    name_es: 'ENS-MO-08 — Gestión de Proveedores',
    name_ru: 'ENS-MO-08 — Управление поставщиками',
    questions: [
      {
        id: 'ENS-MO-08',
        blockId: 'ens-mo-08-gestion-proveedores',
        text_en: 'Supplier Management - Are supplier security requirements defined?',
        text_es: 'Gestión de Proveedores - ¿Los requisitos de seguridad de proveedores están definidos?',
        text_ru: 'Управление поставщиками - Определены ли требования безопасности поставщиков?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-09-planificacion-continuidad',
    name_en: 'ENS-MO-09 — Business Continuity Planning',
    name_es: 'ENS-MO-09 — Planificación de Continuidad',
    name_ru: 'ENS-MO-09 — Планирование непрерывности',
    questions: [
      {
        id: 'ENS-MO-09',
        blockId: 'ens-mo-09-planificacion-continuidad',
        text_en: 'Business Continuity Planning - Are business continuity plans documented?',
        text_es: 'Planificación de Continuidad - ¿Los planes de continuidad del negocio están documentados?',
        text_ru: 'Планирование непрерывности - Документированы ли планы непрерывности бизнеса?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-10-gestion-cambio',
    name_en: 'ENS-MO-10 — Change Management',
    name_es: 'ENS-MO-10 — Gestión del Cambio',
    name_ru: 'ENS-MO-10 — Управление изменениями',
    questions: [
      {
        id: 'ENS-MO-10',
        blockId: 'ens-mo-10-gestion-cambio',
        text_en: 'Change Management - Is a change management process implemented?',
        text_es: 'Gestión del Cambio - ¿Se implementa un proceso de gestión del cambio?',
        text_ru: 'Управление изменениями - Реализован ли процесс управления изменениями?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-11-gestion-configuracion',
    name_en: 'ENS-MO-11 — Configuration Management',
    name_es: 'ENS-MO-11 — Gestión de Configuración',
    name_ru: 'ENS-MO-11 — Управление конфигурацией',
    questions: [
      {
        id: 'ENS-MO-11',
        blockId: 'ens-mo-11-gestion-configuracion',
        text_en: 'Configuration Management - Is configuration management implemented?',
        text_es: 'Gestión de Configuración - ¿Se implementa la gestión de configuración?',
        text_ru: 'Управление конфигурацией - Реализовано ли управление конфигурацией?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-12-gestion-capacidad',
    name_en: 'ENS-MO-12 — Capacity Management',
    name_es: 'ENS-MO-12 — Gestión de Capacidad',
    name_ru: 'ENS-MO-12 — Управление мощностями',
    questions: [
      {
        id: 'ENS-MO-12',
        blockId: 'ens-mo-12-gestion-capacidad',
        text_en: 'Capacity Management - Is capacity planning and management implemented?',
        text_es: 'Gestión de Capacidad - ¿La planificación y gestión de capacidad está implementada?',
        text_ru: 'Управление мощностями - Реализовано ли планирование и управление мощностями?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mo-13-gestion-operaciones',
    name_en: 'ENS-MO-13 — Operations Management',
    name_es: 'ENS-MO-13 — Gestión de Operaciones',
    name_ru: 'ENS-MO-13 — Управление операциями',
    questions: [
      {
        id: 'ENS-MO-13',
        blockId: 'ens-mo-13-gestion-operaciones',
        text_en: 'Operations Management - Are operational procedures documented?',
        text_es: 'Gestión de Operaciones - ¿Los procedimientos operativos están documentados?',
        text_ru: 'Управление операциями - Документированы ли операционные процедуры?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-14-gestion-comunicaciones',
    name_en: 'ENS-MO-14 — Communications Management',
    name_es: 'ENS-MO-14 — Gestión de Comunicaciones',
    name_ru: 'ENS-MO-14 — Управление коммуникациями',
    questions: [
      {
        id: 'ENS-MO-14',
        blockId: 'ens-mo-14-gestion-comunicaciones',
        text_en: 'Communications Management - Are communication security controls implemented?',
        text_es: 'Gestión de Comunicaciones - ¿Los controles de seguridad de comunicaciones están implementados?',
        text_ru: 'Управление коммуникациями - Реализованы ли средства контроля безопасности коммуникаций?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-15-gestion-seguridad-red',
    name_en: 'ENS-MO-15 — Network Security Management',
    name_es: 'ENS-MO-15 — Gestión de Seguridad de Red',
    name_ru: 'ENS-MO-15 — Управление сетевой безопасностью',
    questions: [
      {
        id: 'ENS-MO-15',
        blockId: 'ens-mo-15-gestion-seguridad-red',
        text_en: 'Network Security Management - Are network security controls implemented?',
        text_es: 'Gestión de Seguridad de Red - ¿Los controles de seguridad de red están implementados?',
        text_ru: 'Управление сетевой безопасностью - Реализованы ли средства контроля сетевой безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-16-gestion-acceso',
    name_en: 'ENS-MO-16 — Access Control Management',
    name_es: 'ENS-MO-16 — Gestión de Control de Acceso',
    name_ru: 'ENS-MO-16 — Управление контролем доступа',
    questions: [
      {
        id: 'ENS-MO-16',
        blockId: 'ens-mo-16-gestion-acceso',
        text_en: 'Access Control Management - Are access control policies implemented?',
        text_es: 'Gestión de Control de Acceso - ¿Las políticas de control de acceso están implementadas?',
        text_ru: 'Управление контролем доступа - Реализованы ли политики контроля доступа?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-17-gestion-identidad',
    name_en: 'ENS-MO-17 — Identity Management',
    name_es: 'ENS-MO-17 — Gestión de Identidad',
    name_ru: 'ENS-MO-17 — Управление идентификацией',
    questions: [
      {
        id: 'ENS-MO-17',
        blockId: 'ens-mo-17-gestion-identidad',
        text_en: 'Identity Management - Is identity and access management implemented?',
        text_es: 'Gestión de Identidad - ¿La gestión de identidad y acceso está implementada?',
        text_ru: 'Управление идентификацией - Реализовано ли управление идентификацией и доступом?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-18-cifrado',
    name_en: 'ENS-MO-18 — Encryption',
    name_es: 'ENS-MO-18 — Cifrado',
    name_ru: 'ENS-MO-18 — Шифрование',
    questions: [
      {
        id: 'ENS-MO-18',
        blockId: 'ens-mo-18-cifrado',
        text_en: 'Encryption - Are encryption controls implemented for sensitive data?',
        text_es: 'Cifrado - ¿Los controles de cifrado están implementados para datos sensibles?',
        text_ru: 'Шифрование - Реализованы ли средства шифрования для чувствительных данных?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-19-gestion-vulnerabilidades',
    name_en: 'ENS-MO-19 — Vulnerability Management',
    name_es: 'ENS-MO-19 — Gestión de Vulnerabilidades',
    name_ru: 'ENS-MO-19 — Управление уязвимостями',
    questions: [
      {
        id: 'ENS-MO-19',
        blockId: 'ens-mo-19-gestion-vulnerabilidades',
        text_en: 'Vulnerability Management - Is vulnerability management implemented?',
        text_es: 'Gestión de Vulnerabilidades - ¿La gestión de vulnerabilidades está implementada?',
        text_ru: 'Управление уязвимостями - Реализовано ли управление уязвимостями?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-20-gestion-incidentes',
    name_en: 'ENS-MO-20 — Incident Management',
    name_es: 'ENS-MO-20 — Gestión de Incidentes',
    name_ru: 'ENS-MO-20 — Управление инцидентами',
    questions: [
      {
        id: 'ENS-MO-20',
        blockId: 'ens-mo-20-gestion-incidentes',
        text_en: 'Incident Management - Is an incident management process implemented?',
        text_es: 'Gestión de Incidentes - ¿Un proceso de gestión de incidentes está implementado?',
        text_ru: 'Управление инцидентами - Реализован ли процесс управления инцидентами?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-21-gestion-logging',
    name_en: 'ENS-MO-21 — Logging Management',
    name_es: 'ENS-MO-21 — Gestión de Registros',
    name_ru: 'ENS-MO-21 — Управление логированием',
    questions: [
      {
        id: 'ENS-MO-21',
        blockId: 'ens-mo-21-gestion-logging',
        text_en: 'Logging Management - Is logging and monitoring implemented?',
        text_es: 'Gestión de Registros - ¿El registro y monitoreo está implementado?',
        text_ru: 'Управление логированием - Реализовано ли логирование и мониторинг?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-22-gestion-copia-seguridad',
    name_en: 'ENS-MO-22 — Backup Management',
    name_es: 'ENS-MO-22 — Gestión de Copias de Seguridad',
    name_ru: 'ENS-MO-22 — Управление резервным копированием',
    questions: [
      {
        id: 'ENS-MO-22',
        blockId: 'ens-mo-22-gestion-copia-seguridad',
        text_en: 'Backup Management - Are backup and recovery procedures implemented?',
        text_es: 'Gestión de Copias de Seguridad - ¿Los procedimientos de respaldo y recuperación están implementados?',
        text_ru: 'Управление резервным копированием - Реализованы ли процедуры резервного копирования и восстановления?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-23-gestion-desarrollo',
    name_en: 'ENS-MO-23 — Development Management',
    name_es: 'ENS-MO-23 — Gestión del Desarrollo',
    name_ru: 'ENS-MO-23 — Управление разработкой',
    questions: [
      {
        id: 'ENS-MO-23',
        blockId: 'ens-mo-23-gestion-desarrollo',
        text_en: 'Development Management - Are secure development practices implemented?',
        text_es: 'Gestión del Desarrollo - ¿Las prácticas de desarrollo seguro están implementadas?',
        text_ru: 'Управление разработкой - Реализованы ли практики безопасной разработки?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-24-auditorias-periodicas',
    name_en: 'ENS-MO-24 — Periodic Audits',
    name_es: 'ENS-MO-24 — Auditorías Periódicas',
    name_ru: 'ENS-MO-24 — Периодические аудиты',
    questions: [
      {
        id: 'ENS-MO-24',
        blockId: 'ens-mo-24-auditorias-periodicas',
        text_en: 'Periodic Audits - Are periodic security audits conducted?',
        text_es: 'Auditorías Periódicas - ¿Las auditorías de seguridad periódicas se realizan?',
        text_ru: 'Периодические аудиты - Проводятся ли периодические аудиты безопасности?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mo-25-mejora-continua',
    name_en: 'ENS-MO-25 — Continuous Improvement',
    name_es: 'ENS-MO-25 — Mejora Continua',
    name_ru: 'ENS-MO-25 — Постоянное улучшение',
    questions: [
      {
        id: 'ENS-MO-25',
        blockId: 'ens-mo-25-mejora-continua',
        text_en: 'Continuous Improvement - Is a continuous improvement process implemented?',
        text_es: 'Mejora Continua - ¿Un proceso de mejora continua está implementado?',
        text_ru: 'Постоянное улучшение - Реализован ли процесс постоянного улучшения?',
        weight: 3,
      },
    ],
  },
];

export const ENS_MEDIO_MP_PROTECCION_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-mp-01-seguridad-perimetral',
    name_en: 'ENS-MP-01 — Perimeter Security',
    name_es: 'ENS-MP-01 — Seguridad Perimetral',
    name_ru: 'ENS-MP-01 — Периметровая безопасность',
    questions: [
      {
        id: 'ENS-MP-01',
        blockId: 'ens-mp-01-seguridad-perimetral',
        text_en: 'Perimeter Security - Are perimeter security controls implemented?',
        text_es: 'Seguridad Perimetral - ¿Los controles de seguridad perimetral están implementados?',
        text_ru: 'Периметровая безопасность - Реализованы ли средства контроля периметровой безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-02-seguridad-red',
    name_en: 'ENS-MP-02 — Network Security',
    name_es: 'ENS-MP-02 — Seguridad de Red',
    name_ru: 'ENS-MP-02 — Сетевая безопасность',
    questions: [
      {
        id: 'ENS-MP-02',
        blockId: 'ens-mp-02-seguridad-red',
        text_en: 'Network Security - Are network security controls implemented?',
        text_es: 'Seguridad de Red - ¿Los controles de seguridad de red están implementados?',
        text_ru: 'Сетевая безопасность - Реализованы ли средства контроля сетевой безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-03-control-acceso',
    name_en: 'ENS-MP-03 — Access Control',
    name_es: 'ENS-MP-03 — Control de Acceso',
    name_ru: 'ENS-MP-03 — Контроль доступа',
    questions: [
      {
        id: 'ENS-MP-03',
        blockId: 'ens-mp-03-control-acceso',
        text_en: 'Access Control - Are access control mechanisms implemented?',
        text_es: 'Control de Acceso - ¿Los mecanismos de control de acceso están implementados?',
        text_ru: 'Контроль доступа - Реализованы ли механизмы контроля доступа?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-04-autenticacion',
    name_en: 'ENS-MP-04 — Authentication',
    name_es: 'ENS-MP-04 — Autenticación',
    name_ru: 'ENS-MP-04 — Аутентификация',
    questions: [
      {
        id: 'ENS-MP-04',
        blockId: 'ens-mp-04-autenticacion',
        text_en: 'Authentication - Are strong authentication mechanisms implemented?',
        text_es: 'Autenticación - ¿Los mecanismos de autenticación fuerte están implementados?',
        text_ru: 'Аутентификация - Реализованы ли механизмы сильной аутентификации?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-05-gestion-identidades',
    name_en: 'ENS-MP-05 — Identity Management',
    name_es: 'ENS-MP-05 — Gestión de Identidades',
    name_ru: 'ENS-MP-05 — Управление идентификацией',
    questions: [
      {
        id: 'ENS-MP-05',
        blockId: 'ens-mp-05-gestion-identidades',
        text_en: 'Identity Management - Is identity management implemented?',
        text_es: 'Gestión de Identidades - ¿La gestión de identidades está implementada?',
        text_ru: 'Управление идентификацией - Реализовано ли управление идентификацией?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-06-proteccion-malware',
    name_en: 'ENS-MP-06 — Malware Protection',
    name_es: 'ENS-MP-06 — Protección contra Malware',
    name_ru: 'ENS-MP-06 — Защита от вредоносного ПО',
    questions: [
      {
        id: 'ENS-MP-06',
        blockId: 'ens-mp-06-proteccion-malware',
        text_en: 'Malware Protection - Are malware protection controls implemented?',
        text_es: 'Protección contra Malware - ¿Los controles de protección contra malware están implementados?',
        text_ru: 'Защита от вредоносного ПО - Реализованы ли средства защиты от вредоносного ПО?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-07-proteccion-email',
    name_en: 'ENS-MP-07 — Email Protection',
    name_es: 'ENS-MP-07 — Protección del Correo Electrónico',
    name_ru: 'ENS-MP-07 — Защита электронной почты',
    questions: [
      {
        id: 'ENS-MP-07',
        blockId: 'ens-mp-07-proteccion-email',
        text_en: 'Email Protection - Is email security protection implemented?',
        text_es: 'Protección del Correo Electrónico - ¿La protección de seguridad del correo electrónico está implementada?',
        text_ru: 'Защита электронной почты - Реализована ли защита безопасности электронной почты?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mp-08-cifrado-datos',
    name_en: 'ENS-MP-08 — Data Encryption',
    name_es: 'ENS-MP-08 — Cifrado de Datos',
    name_ru: 'ENS-MP-08 — Шифрование данных',
    questions: [
      {
        id: 'ENS-MP-08',
        blockId: 'ens-mp-08-cifrado-datos',
        text_en: 'Data Encryption - Is data encryption implemented for sensitive information?',
        text_es: 'Cifrado de Datos - ¿El cifrado de datos está implementado para información sensible?',
        text_ru: 'Шифрование данных - Реализовано ли шифрование данных для конфиденциальной информации?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-09-gestion-claves',
    name_en: 'ENS-MP-09 — Key Management',
    name_es: 'ENS-MP-09 — Gestión de Claves',
    name_ru: 'ENS-MP-09 — Управление ключами',
    questions: [
      {
        id: 'ENS-MP-09',
        blockId: 'ens-mp-09-gestion-claves',
        text_en: 'Key Management - Is cryptographic key management implemented?',
        text_es: 'Gestión de Claves - ¿La gestión de claves criptográficas está implementada?',
        text_ru: 'Управление ключами - Реализовано ли управление криптографическими ключами?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-10-proteccion-sistemas',
    name_en: 'ENS-MP-10 — System Protection',
    name_es: 'ENS-MP-10 — Protección de Sistemas',
    name_ru: 'ENS-MP-10 — Защита систем',
    questions: [
      {
        id: 'ENS-MP-10',
        blockId: 'ens-mp-10-proteccion-sistemas',
        text_en: 'System Protection - Are system hardening controls implemented?',
        text_es: 'Protección de Sistemas - ¿Los controles de endurecimiento de sistemas están implementados?',
        text_ru: 'Защита систем - Реализованы ли средства усиления защиты систем?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-11-proteccion-aplicaciones',
    name_en: 'ENS-MP-11 — Application Protection',
    name_es: 'ENS-MP-11 — Protección de Aplicaciones',
    name_ru: 'ENS-MP-11 — Защита приложений',
    questions: [
      {
        id: 'ENS-MP-11',
        blockId: 'ens-mp-11-proteccion-aplicaciones',
        text_en: 'Application Protection - Are application security controls implemented?',
        text_es: 'Protección de Aplicaciones - ¿Los controles de seguridad de aplicaciones están implementados?',
        text_ru: 'Защита приложений - Реализованы ли средства безопасности приложений?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-12-proteccion-bases-datos',
    name_en: 'ENS-MP-12 — Database Protection',
    name_es: 'ENS-MP-12 — Protección de Bases de Datos',
    name_ru: 'ENS-MP-12 — Защита баз данных',
    questions: [
      {
        id: 'ENS-MP-12',
        blockId: 'ens-mp-12-proteccion-bases-datos',
        text_en: 'Database Protection - Are database security controls implemented?',
        text_es: 'Protección de Bases de Datos - ¿Los controles de seguridad de bases de datos están implementados?',
        text_ru: 'Защита баз данных - Реализованы ли средства безопасности баз данных?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-13-seguridad-fisica',
    name_en: 'ENS-MP-13 — Physical Security',
    name_es: 'ENS-MP-13 — Seguridad Física',
    name_ru: 'ENS-MP-13 — Физическая безопасность',
    questions: [
      {
        id: 'ENS-MP-13',
        blockId: 'ens-mp-13-seguridad-fisica',
        text_en: 'Physical Security - Are physical security controls implemented?',
        text_es: 'Seguridad Física - ¿Los controles de seguridad física están implementados?',
        text_ru: 'Физическая безопасность - Реализованы ли средства физической безопасности?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-14-proteccion-dispositivos',
    name_en: 'ENS-MP-14 — Device Protection',
    name_es: 'ENS-MP-14 — Protección de Dispositivos',
    name_ru: 'ENS-MP-14 — Защита устройств',
    questions: [
      {
        id: 'ENS-MP-14',
        blockId: 'ens-mp-14-proteccion-dispositivos',
        text_en: 'Device Protection - Are mobile device security controls implemented?',
        text_es: 'Protección de Dispositivos - ¿Los controles de seguridad de dispositivos móviles están implementados?',
        text_ru: 'Защита устройств - Реализованы ли средства безопасности мобильных устройств?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mp-15-proteccion-nube',
    name_en: 'ENS-MP-15 — Cloud Protection',
    name_es: 'ENS-MP-15 — Protección en la Nube',
    name_ru: 'ENS-MP-15 — Защита в облаке',
    questions: [
      {
        id: 'ENS-MP-15',
        blockId: 'ens-mp-15-proteccion-nube',
        text_en: 'Cloud Protection - Are cloud security controls implemented?',
        text_es: 'Protección en la Nube - ¿Los controles de seguridad en la nube están implementados?',
        text_ru: 'Защита в облаке - Реализованы ли средства облачной безопасности?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-16-monitoreo-deteccion',
    name_en: 'ENS-MP-16 — Monitoring and Detection',
    name_es: 'ENS-MP-16 — Monitoreo y Detección',
    name_ru: 'ENS-MP-16 — Мониторинг и обнаружение',
    questions: [
      {
        id: 'ENS-MP-16',
        blockId: 'ens-mp-16-monitoreo-deteccion',
        text_en: 'Monitoring and Detection - Are security monitoring and detection systems implemented?',
        text_es: 'Monitoreo y Detección - ¿Los sistemas de monitoreo y detección de seguridad están implementados?',
        text_ru: 'Мониторинг и обнаружение - Реализованы ли системы мониторинга и обнаружения безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-17-gestion-logging',
    name_en: 'ENS-MP-17 — Logging Management',
    name_es: 'ENS-MP-17 — Gestión de Registros',
    name_ru: 'ENS-MP-17 — Управление логированием',
    questions: [
      {
        id: 'ENS-MP-17',
        blockId: 'ens-mp-17-gestion-logging',
        text_en: 'Logging Management - Is comprehensive logging implemented?',
        text_es: 'Gestión de Registros - ¿El registro integral está implementado?',
        text_ru: 'Управление логированием - Реализовано ли комплексное логирование?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-18-gestion-vulnerabilidades',
    name_en: 'ENS-MP-18 — Vulnerability Management',
    name_es: 'ENS-MP-18 — Gestión de Vulnerabilidades',
    name_ru: 'ENS-MP-18 — Управление уязвимостями',
    questions: [
      {
        id: 'ENS-MP-18',
        blockId: 'ens-mp-18-gestion-vulnerabilidades',
        text_en: 'Vulnerability Management - Is vulnerability scanning and management implemented?',
        text_es: 'Gestión de Vulnerabilidades - ¿El escaneo y gestión de vulnerabilidades está implementado?',
        text_ru: 'Управление уязвимостями - Реализованы ли сканирование и управление уязвимостями?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mp-19-gestion-parches',
    name_en: 'ENS-MP-19 — Patch Management',
    name_es: 'ENS-MP-19 — Gestión de Parches',
    name_ru: 'ENS-MP-19 — Управление патчами',
    questions: [
      {
        id: 'ENS-MP-19',
        blockId: 'ens-mp-19-gestion-parches',
        text_en: 'Patch Management - Is patch management process implemented?',
        text_es: 'Gestión de Parches - ¿El proceso de gestión de parches está implementado?',
        text_ru: 'Управление патчами - Реализован ли процесс управления патчами?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-20-proteccion-web',
    name_en: 'ENS-MP-20 — Web Protection',
    name_es: 'ENS-MP-20 — Protección Web',
    name_ru: 'ENS-MP-20 — Защита веб-приложений',
    questions: [
      {
        id: 'ENS-MP-20',
        blockId: 'ens-mp-20-proteccion-web',
        text_en: 'Web Protection - Are web application security controls implemented?',
        text_es: 'Protección Web - ¿Los controles de seguridad de aplicaciones web están implementados?',
        text_ru: 'Защита веб-приложений - Реализованы ли средства безопасности веб-приложений?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-21-proteccion-dlp',
    name_en: 'ENS-MP-21 — Data Loss Prevention',
    name_es: 'ENS-MP-21 — Prevención de Pérdida de Datos',
    name_ru: 'ENS-MP-21 — Предотвращение утечки данных',
    questions: [
      {
        id: 'ENS-MP-21',
        blockId: 'ens-mp-21-proteccion-dlp',
        text_en: 'Data Loss Prevention - Is DLP protection implemented?',
        text_es: 'Prevención de Pérdida de Datos - ¿La protección DLP está implementada?',
        text_ru: 'Предотвращение утечки данных - Реализована ли защита DLP?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-22-seguridad-wireless',
    name_en: 'ENS-MP-22 — Wireless Security',
    name_es: 'ENS-MP-22 — Seguridad Inalámbrica',
    name_ru: 'ENS-MP-22 — Безопасность беспроводных сетей',
    questions: [
      {
        id: 'ENS-MP-22',
        blockId: 'ens-mp-22-seguridad-wireless',
        text_en: 'Wireless Security - Are wireless network security controls implemented?',
        text_es: 'Seguridad Inalámbrica - ¿Los controles de seguridad de redes inalámbricas están implementados?',
        text_ru: 'Безопасность беспроводных сетей - Реализованы ли средства безопасности беспроводных сетей?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mp-23-proteccion-backup',
    name_en: 'ENS-MP-23 — Backup Protection',
    name_es: 'ENS-MP-23 — Protección de Copias de Seguridad',
    name_ru: 'ENS-MP-23 — Защита резервных копий',
    questions: [
      {
        id: 'ENS-MP-23',
        blockId: 'ens-mp-23-proteccion-backup',
        text_en: 'Backup Protection - Are backup data protection controls implemented?',
        text_es: 'Protección de Copias de Seguridad - ¿Los controles de protección de datos de respaldo están implementados?',
        text_ru: 'Защита резервных копий - Реализованы ли средства защиты данных резервных копий?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mp-24-seguridad-integracion',
    name_en: 'ENS-MP-24 — Integration Security',
    name_es: 'ENS-MP-24 — Seguridad de Integración',
    name_ru: 'ENS-MP-24 — Безопасность интеграций',
    questions: [
      {
        id: 'ENS-MP-24',
        blockId: 'ens-mp-24-seguridad-integracion',
        text_en: 'Integration Security - Are API and integration security controls implemented?',
        text_es: 'Seguridad de Integración - ¿Los controles de seguridad de API e integración están implementados?',
        text_ru: 'Безопасность интеграций - Реализованы ли средства безопасности API и интеграций?',
        weight: 4,
      },
    ],
  },
];

export const ENS_MEDIO_MO_OPERACIONAL_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-mo-op-01-plan-continuidad',
    name_en: 'ENS-MO-OP-01 — Business Continuity Plan',
    name_es: 'ENS-MO-OP-01 — Plan de Continuidad',
    name_ru: 'ENS-MO-OP-01 — План непрерывности',
    questions: [
      {
        id: 'ENS-MO-OP-01',
        blockId: 'ens-mo-op-01-plan-continuidad',
        text_en: 'Business Continuity Plan - Is a business continuity plan documented and tested?',
        text_es: 'Plan de Continuidad - ¿Un plan de continuidad del negocio está documentado y probado?',
        text_ru: 'План непрерывности - Документирован и протестирован ли план непрерывности бизнеса?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-02-gestion-respaldo',
    name_en: 'ENS-MO-OP-02 — Backup Management',
    name_es: 'ENS-MO-OP-02 — Gestión de Respaldo',
    name_ru: 'ENS-MO-OP-02 — Управление резервным копированием',
    questions: [
      {
        id: 'ENS-MO-OP-02',
        blockId: 'ens-mo-op-02-gestion-respaldo',
        text_en: 'Backup Management - Are backup procedures implemented and tested?',
        text_es: 'Gestión de Respaldo - ¿Los procedimientos de respaldo están implementados y probados?',
        text_ru: 'Управление резервным копированием - Реализованы и протестированы ли процедуры резервного копирования?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-03-gestion-incidentes',
    name_en: 'ENS-MO-OP-03 — Incident Management',
    name_es: 'ENS-MO-OP-03 — Gestión de Incidentes',
    name_ru: 'ENS-MO-OP-03 — Управление инцидентами',
    questions: [
      {
        id: 'ENS-MO-OP-03',
        blockId: 'ens-mo-op-03-gestion-incidentes',
        text_en: 'Incident Management - Is an incident management process implemented?',
        text_es: 'Gestión de Incidentes - ¿Un proceso de gestión de incidentes está implementado?',
        text_ru: 'Управление инцидентами - Реализован ли процесс управления инцидентами?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-04-respuesta-incidentes',
    name_en: 'ENS-MO-OP-04 — Incident Response',
    name_es: 'ENS-MO-OP-04 — Respuesta a Incidentes',
    name_ru: 'ENS-MO-OP-04 — Реагирование на инциденты',
    questions: [
      {
        id: 'ENS-MO-OP-04',
        blockId: 'ens-mo-op-04-respuesta-incidentes',
        text_en: 'Incident Response - Is an incident response team designated and trained?',
        text_es: 'Respuesta a Incidentes - ¿Un equipo de respuesta a incidentes está designado y capacitado?',
        text_ru: 'Реагирование на инциденты - Назначена и обучена ли команда реагирования на инциденты?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-05-deteccion-incidentes',
    name_en: 'ENS-MO-OP-05 — Incident Detection',
    name_es: 'ENS-MO-OP-05 — Detección de Incidentes',
    name_ru: 'ENS-MO-OP-05 — Обнаружение инцидентов',
    questions: [
      {
        id: 'ENS-MO-OP-05',
        blockId: 'ens-mo-op-05-deteccion-incidentes',
        text_en: 'Incident Detection - Are incident detection capabilities implemented?',
        text_es: 'Detección de Incidentes - ¿Las capacidades de detección de incidentes están implementadas?',
        text_ru: 'Обнаружение инцидентов - Реализованы ли возможности обнаружения инцидентов?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-06-clasificacion-incidentes',
    name_en: 'ENS-MO-OP-06 — Incident Classification',
    name_es: 'ENS-MO-OP-06 — Clasificación de Incidentes',
    name_ru: 'ENS-MO-OP-06 — Классификация инцидентов',
    questions: [
      {
        id: 'ENS-MO-OP-06',
        blockId: 'ens-mo-op-06-clasificacion-incidentes',
        text_en: 'Incident Classification - Are incidents classified by severity and impact?',
        text_es: 'Clasificación de Incidentes - ¿Los incidentes se clasifican por severidad e impacto?',
        text_ru: 'Классификация инцидентов - Классифицируются ли инциденты по серьезности и воздействию?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-07-notificacion-incidentes',
    name_en: 'ENS-MO-OP-07 — Incident Notification',
    name_es: 'ENS-MO-OP-07 — Notificación de Incidentes',
    name_ru: 'ENS-MO-OP-07 — Уведомление об инцидентах',
    questions: [
      {
        id: 'ENS-MO-OP-07',
        blockId: 'ens-mo-op-07-notificacion-incidentes',
        text_en: 'Incident Notification - Are incidents reported to competent authorities?',
        text_es: 'Notificación de Incidentes - ¿Los incidentes se reportan a las autoridades competentes?',
        text_ru: 'Уведомление об инцидентах - Сообщаются ли инциденты компетентным органам?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-08-analisis-post-incidente',
    name_en: 'ENS-MO-OP-08 — Post-Incident Analysis',
    name_es: 'ENS-MO-OP-08 — Análisis Post-Incidente',
    name_ru: 'ENS-MO-OP-08 — Анализ после инцидента',
    questions: [
      {
        id: 'ENS-MO-OP-08',
        blockId: 'ens-mo-op-08-analisis-post-incidente',
        text_en: 'Post-Incident Analysis - Is post-incident analysis conducted?',
        text_es: 'Análisis Post-Incidente - ¿El análisis post-incidente se realiza?',
        text_ru: 'Анализ после инцидента - Проводится ли анализ после инцидента?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-09-auditorias-internas',
    name_en: 'ENS-MO-OP-09 — Internal Audits',
    name_es: 'ENS-MO-OP-09 — Auditorías Internas',
    name_ru: 'ENS-MO-OP-09 — Внутренние аудиты',
    questions: [
      {
        id: 'ENS-MO-OP-09',
        blockId: 'ens-mo-op-09-auditorias-internas',
        text_en: 'Internal Audits - Are internal security audits conducted regularly?',
        text_es: 'Auditorías Internas - ¿Las auditorías de seguridad internas se realizan regularmente?',
        text_ru: 'Внутренние аудиты - Проводятся ли регулярно внутренние аудиты безопасности?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mo-op-10-gestion-hallazgos',
    name_en: 'ENS-MO-OP-10 — Findings Management',
    name_es: 'ENS-MO-OP-10 — Gestión de Hallazgos',
    name_ru: 'ENS-MO-OP-10 — Управление результатами аудита',
    questions: [
      {
        id: 'ENS-MO-OP-10',
        blockId: 'ens-mo-op-10-gestion-hallazgos',
        text_en: 'Findings Management - Are audit findings documented and tracked?',
        text_es: 'Gestión de Hallazgos - ¿Los hallazgos de auditoría están documentados y rastreados?',
        text_ru: 'Управление результатами аудита - Документируются и отслеживаются ли результаты аудита?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-11-acciones-correctivas',
    name_en: 'ENS-MO-OP-11 — Corrective Actions',
    name_es: 'ENS-MO-OP-11 — Acciones Correctivas',
    name_ru: 'ENS-MO-OP-11 — Корректирующие действия',
    questions: [
      {
        id: 'ENS-MO-OP-11',
        blockId: 'ens-mo-op-11-acciones-correctivas',
        text_en: 'Corrective Actions - Are corrective actions implemented for audit findings?',
        text_es: 'Acciones Correctivas - ¿Las acciones correctivas se implementan para los hallazgos de auditoría?',
        text_ru: 'Корректирующие действия - Реализуются ли корректирующие действия по результатам аудита?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-12-gestion-cambio',
    name_en: 'ENS-MO-OP-12 — Change Management',
    name_es: 'ENS-MO-OP-12 — Gestión del Cambio',
    name_ru: 'ENS-MO-OP-12 — Управление изменениями',
    questions: [
      {
        id: 'ENS-MO-OP-12',
        blockId: 'ens-mo-op-12-gestion-cambio',
        text_en: 'Change Management - Is a change management process implemented?',
        text_es: 'Gestión del Cambio - ¿Un proceso de gestión del cambio está implementado?',
        text_ru: 'Управление изменениями - Реализован ли процесс управления изменениями?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-13-gestion-configuracion',
    name_en: 'ENS-MO-OP-13 — Configuration Management',
    name_es: 'ENS-MO-OP-13 — Gestión de Configuración',
    name_ru: 'ENS-MO-OP-13 — Управление конфигурацией',
    questions: [
      {
        id: 'ENS-MO-OP-13',
        blockId: 'ens-mo-op-13-gestion-configuracion',
        text_en: 'Configuration Management - Is configuration management implemented?',
        text_es: 'Gestión de Configuración - ¿La gestión de configuración está implementada?',
        text_ru: 'Управление конфигурацией - Реализовано ли управление конфигурацией?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-14-gestion-capacidad',
    name_en: 'ENS-MO-OP-14 — Capacity Management',
    name_es: 'ENS-MO-OP-14 — Gestión de Capacidad',
    name_ru: 'ENS-MO-OP-14 — Управление мощностями',
    questions: [
      {
        id: 'ENS-MO-OP-14',
        blockId: 'ens-mo-op-14-gestion-capacidad',
        text_en: 'Capacity Management - Is capacity planning and management implemented?',
        text_es: 'Gestión de Capacidad - ¿La planificación y gestión de capacidad está implementada?',
        text_ru: 'Управление мощностями - Реализовано ли планирование и управление мощностями?',
        weight: 3,
      },
    ],
  },
  {
    id: 'ens-mo-op-15-gestion-operaciones',
    name_en: 'ENS-MO-OP-15 — Operations Management',
    name_es: 'ENS-MO-OP-15 — Gestión de Operaciones',
    name_ru: 'ENS-MO-OP-15 — Управление операциями',
    questions: [
      {
        id: 'ENS-MO-OP-15',
        blockId: 'ens-mo-op-15-gestion-operaciones',
        text_en: 'Operations Management - Are operational procedures documented?',
        text_es: 'Gestión de Operaciones - ¿Los procedimientos operativos están documentados?',
        text_ru: 'Управление операциями - Документированы ли операционные процедуры?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-16-monitoreo-seguridad',
    name_en: 'ENS-MO-OP-16 — Security Monitoring',
    name_es: 'ENS-MO-OP-16 — Monitoreo de Seguridad',
    name_ru: 'ENS-MO-OP-16 — Мониторинг безопасности',
    questions: [
      {
        id: 'ENS-MO-OP-16',
        blockId: 'ens-mo-op-16-monitoreo-seguridad',
        text_en: 'Security Monitoring - Is continuous security monitoring implemented?',
        text_es: 'Monitoreo de Seguridad - ¿El monitoreo continuo de seguridad está implementado?',
        text_ru: 'Мониторинг безопасности - Реализован ли непрерывный мониторинг безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-17-gestion-logging',
    name_en: 'ENS-MO-OP-17 — Logging Management',
    name_es: 'ENS-MO-OP-17 — Gestión de Registros',
    name_ru: 'ENS-MO-OP-17 — Управление логированием',
    questions: [
      {
        id: 'ENS-MO-OP-17',
        blockId: 'ens-mo-op-17-gestion-logging',
        text_en: 'Logging Management - Is comprehensive logging implemented?',
        text_es: 'Gestión de Registros - ¿El registro integral está implementado?',
        text_ru: 'Управление логированием - Реализовано ли комплексное логирование?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-18-gestion-vulnerabilidades',
    name_en: 'ENS-MO-OP-18 — Vulnerability Management',
    name_es: 'ENS-MO-OP-18 — Gestión de Vulnerabilidades',
    name_ru: 'ENS-MO-OP-18 — Управление уязвимостями',
    questions: [
      {
        id: 'ENS-MO-OP-18',
        blockId: 'ens-mo-op-18-gestion-vulnerabilidades',
        text_en: 'Vulnerability Management - Is vulnerability management implemented?',
        text_es: 'Gestión de Vulnerabilidades - ¿La gestión de vulnerabilidades está implementada?',
        text_ru: 'Управление уязвимостями - Реализовано ли управление уязвимостями?',
        weight: 5,
      },
    ],
  },
  {
    id: 'ens-mo-op-19-gestion-parches',
    name_en: 'ENS-MO-OP-19 — Patch Management',
    name_es: 'ENS-MO-OP-19 — Gestión de Parches',
    name_ru: 'ENS-MO-OP-19 — Управление патчами',
    questions: [
      {
        id: 'ENS-MO-OP-19',
        blockId: 'ens-mo-op-19-gestion-parches',
        text_en: 'Patch Management - Is patch management process implemented?',
        text_es: 'Gestión de Parches - ¿El proceso de gestión de parches está implementado?',
        text_ru: 'Управление патчами - Реализован ли процесс управления патчами?',
        weight: 4,
      },
    ],
  },
  {
    id: 'ens-mo-op-20-mejora-continua',
    name_en: 'ENS-MO-OP-20 — Continuous Improvement',
    name_es: 'ENS-MO-OP-20 — Mejora Continua',
    name_ru: 'ENS-MO-OP-20 — Постоянное улучшение',
    questions: [
      {
        id: 'ENS-MO-OP-20',
        blockId: 'ens-mo-op-20-mejora-continua',
        text_en: 'Continuous Improvement - Is a continuous improvement process implemented?',
        text_es: 'Mejora Continua - ¿Un proceso de mejora continua está implementado?',
        text_ru: 'Постоянное улучшение - Реализован ли процесс постоянного улучшения?',
        weight: 3,
      },
    ],
  },
];

// ENS Required Documents (ENS policies)
export const ENS_DOCUMENTS_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-doc-policy',
    name_en: 'ENS Policy Documents',
    name_es: 'Documentos de Política ENS',
    name_ru: 'Документы политики ENS',
    questions: [
      { id: 'ens-doc-1', blockId: 'ens-doc-policy', text_en: 'ENS Security Policy documented and approved?', text_es: '¿Política de Seguridad ENS documentada y aprobada?', text_ru: 'Политика безопасности ENS документирована и утверждена?' },
      { id: 'ens-doc-2', blockId: 'ens-doc-policy', text_en: 'Asset management and classification policy?', text_es: '¿Política de gestión y clasificación de activos?', text_ru: 'Политика управления и классификации активов?' },
    ],
  },
  {
    id: 'ens-doc-risk',
    name_en: 'Risk & Incident Documents',
    name_es: 'Documentos de Riesgo e Incidentes',
    name_ru: 'Документы по рискам и инцидентам',
    questions: [
      { id: 'ens-doc-3', blockId: 'ens-doc-risk', text_en: 'Risk management methodology documented?', text_es: '¿Metodología de gestión de riesgos documentada?', text_ru: 'Методология управления рисками документирована?' },
      { id: 'ens-doc-4', blockId: 'ens-doc-risk', text_en: 'Incident management procedures?', text_es: '¿Procedimientos de gestión de incidentes?', text_ru: 'Процедуры управления инцидентами?' },
    ],
  },
];

// ENS Required Processes
export const ENS_PROCESSES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-proc-risk',
    name_en: 'Risk Management Process',
    name_es: 'Proceso de Gestión de Riesgos',
    name_ru: 'Процесс управления рисками',
    questions: [
      { id: 'ens-proc-1', blockId: 'ens-proc-risk', text_en: 'ENS risk assessment process implemented?', text_es: '¿Proceso de evaluación de riesgos ENS implementado?', text_ru: 'Процесс оценки рисков ENS реализован?' },
      { id: 'ens-proc-2', blockId: 'ens-proc-risk', text_en: 'Risk treatment and monitoring process?', text_es: '¿Proceso de tratamiento y monitoreo de riesgos?', text_ru: 'Процесс обработки и мониторинга рисков?' },
    ],
  },
  {
    id: 'ens-proc-incident',
    name_en: 'Incident Process',
    name_es: 'Proceso de Incidentes',
    name_ru: 'Процесс инцидентов',
    questions: [
      { id: 'ens-proc-3', blockId: 'ens-proc-incident', text_en: 'Incident detection and response process?', text_es: '¿Proceso de detección y respuesta a incidentes?', text_ru: 'Процесс выявления и реагирования на инциденты?' },
      { id: 'ens-proc-4', blockId: 'ens-proc-incident', text_en: 'Notification to competent authorities?', text_es: '¿Notificación a autoridades competentes?', text_ru: 'Уведомление компетентных органов?' },
    ],
  },
];

// ENS Required Roles (Responsable del Sistema, Responsable de Seguridad)
export const ENS_ROLES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'ens-roles-key',
    name_en: 'Key Roles',
    name_es: 'Roles Clave',
    name_ru: 'Ключевые роли',
    questions: [
      { id: 'ens-role-1', blockId: 'ens-roles-key', text_en: 'Responsable del Sistema (System Owner) assigned?', text_es: '¿Responsable del Sistema asignado?', text_ru: 'Назначен ответственный за систему?' },
      { id: 'ens-role-2', blockId: 'ens-roles-key', text_en: 'Responsable de Seguridad (Security Officer) assigned?', text_es: '¿Responsable de Seguridad asignado?', text_ru: 'Назначен ответственный за безопасность?' },
      { id: 'ens-role-3', blockId: 'ens-roles-key', text_en: 'CIS/DPO role defined where applicable?', text_es: '¿Rol CIS/DPO definido cuando aplica?', text_ru: 'Роль CIS/DPO определена при необходимости?' },
    ],
  },
];

// Combine all ENS MEDIO+ blocks
export const ENS_MEDIO_QUESTIONNAIRES = {
  SELF_ASSESSMENT: [
    ...ENS_MEDIO_MO_ORGANIZATIVO_BLOCKS,
    ...ENS_MEDIO_MP_PROTECCION_BLOCKS,
    ...ENS_MEDIO_MO_OPERACIONAL_BLOCKS,
  ],
  DOCUMENTS: ENS_DOCUMENTS_BLOCKS,
  PROCESSES: ENS_PROCESSES_BLOCKS,
  ROLES: ENS_ROLES_BLOCKS,
};

